import styled from "styled-components";
import { Link as LinkRR } from "react-router-dom";
import { PagesStyleType } from "./Pages.type";

const ListItem = styled.li.attrs<PagesStyleType>((props) => ({
  className: `${props.active && "!text-black underline"} 
  text-neutral-300 hover:text-black active:text-black cursor-pointer font-bold`,
}))<PagesStyleType>``;

const DatosContainer = styled.div.attrs({
  className:
  "bg-neutral-100 rounded-lg px-2 py-12 flex flex-row ",
})``;

const PersonalInfoGrouping = styled.div.attrs({
  className:
      "flex-auto flex flex-column sm:border-2 border-neutral-100 border-l-zinc-400"
})``;

const InfoGrouping = styled.div.attrs({
  className:
    "m-2",
})``;
const PatientInfoGrouping = styled.div.attrs({
  className: "flex flex-col flex-wrap gap-7 w-full sm:w-full mb-16",
})``;

const InfoContainer = styled.div.attrs({
  className: "flex flex-wrap gap-8 sm:gap-0",
})``;

const IndividualInfo = styled.div.attrs({
  className: "flex flex-col justify-between my-4",
})``;

const Header = styled.p.attrs({
  className: "text-xs font-normal text-zinc-400 leading-4",
})``;


const SubHeader = styled.p.attrs({
  className: "text-sm font-semibold text-neutral-700 leading-5",
})``;

const Divider = styled.div.attrs({
  className: "bg-stone-300 h-fit h-px w-full lg:h-64 lg:w-px",
})``;

const RowTitle = styled.p.attrs({
  className: "text-[14px] font-[700px] text-[#DF6865] leading-4 mb-3",
})``;

export default {
  ListItem,
  DatosContainer,
  InfoGrouping,
  PatientInfoGrouping,
  PersonalInfoGrouping,
  InfoContainer,
  IndividualInfo,
  Header,
  SubHeader,
  Divider,
  RowTitle
};
